if (!customElements.get('product-calc-shipping-rate-block')) {
  const ZIP_LENGTH = 8;
  const DEBOUNCE_TIME = 550;

  const BRAZIL_PROVINCES_BY_ZIP = [
    { min: 1000, max: 19999, province: 'São Paulo', provinceCode: 'SP' },
    { min: 20000, max: 28999, province: 'Rio de Janeiro', provinceCode: 'RJ' },
    { min: 29000, max: 29999, province: 'Espírito Santo', provinceCode: 'ES' },
    { min: 30000, max: 39999, province: 'Minas Gerais', provinceCode: 'MG' },
    { min: 40000, max: 48999, province: 'Bahia', provinceCode: 'BA' },
    { min: 49000, max: 49999, province: 'Sergipe', provinceCode: 'SE' },
    { min: 50000, max: 56999, province: 'Pernambuco', provinceCode: 'PE' },
    { min: 57000, max: 57999, province: 'Alagoas', provinceCode: 'AL' },
    { min: 58000, max: 58999, province: 'Paraíba', provinceCode: 'PB' },
    { min: 59000, max: 59999, province: 'Rio Grande do Norte', provinceCode: 'RN' },
    { min: 60000, max: 63999, province: 'Ceará', provinceCode: 'CE' },
    { min: 64000, max: 64999, province: 'Piauí', provinceCode: 'PI' },
    { min: 65000, max: 65999, province: 'Maranhão', provinceCode: 'MA' },
    { min: 66000, max: 68899, province: 'Pará', provinceCode: 'PA' },
    { min: 68900, max: 68999, province: 'Amapá', provinceCode: 'AP' },
    { min: 69000, max: 69299, province: 'Amazonas', provinceCode: 'AM' },
    { min: 69300, max: 69399, province: 'Roraima', provinceCode: 'RR' },
    { min: 69400, max: 69899, province: 'Amazonas', provinceCode: 'AM' },
    { min: 69900, max: 69999, province: 'Acre', provinceCode: 'AC' },
    { min: 70000, max: 72799, province: 'Distrito Federal', provinceCode: 'DF' },
    { min: 72800, max: 72999, province: 'Goiás', provinceCode: 'GO' },
    { min: 73000, max: 73699, province: 'Distrito Federal', provinceCode: 'DF' },
    { min: 73700, max: 76799, province: 'Goiás', provinceCode: 'GO' },
    { min: 77000, max: 77999, province: 'Tocantins', provinceCode: 'TO' },
    { min: 78000, max: 78899, province: 'Mato Grosso', provinceCode: 'MT' },
    { min: 78900, max: 78999, province: 'Rondônia', provinceCode: 'RO' },
    { min: 79000, max: 79999, province: 'Mato Grosso do Sul', provinceCode: 'MS' },
    { min: 80000, max: 87999, province: 'Paraná', provinceCode: 'PR' },
    { min: 88000, max: 89999, province: 'Santa Catarina', provinceCode: 'SC' },
    { min: 90000, max: 99999, province: 'Rio Grande do Sul', provinceCode: 'RS' },
  ];

  const UF_TO_STATE_NAME = {
    AC: 'Acre',
    AL: 'Alagoas',
    AP: 'Amapá',
    AM: 'Amazonas',
    BA: 'Bahia',
    CE: 'Ceará',
    DF: 'Distrito Federal',
    ES: 'Espírito Santo',
    GO: 'Goiás',
    MA: 'Maranhão',
    MT: 'Mato Grosso',
    MS: 'Mato Grosso do Sul',
    MG: 'Minas Gerais',
    PA: 'Pará',
    PB: 'Paraíba',
    PR: 'Paraná',
    PE: 'Pernambuco',
    PI: 'Piauí',
    RJ: 'Rio de Janeiro',
    RN: 'Rio Grande do Norte',
    RS: 'Rio Grande do Sul',
    RO: 'Rondônia',
    RR: 'Roraima',
    SC: 'Santa Catarina',
    SP: 'São Paulo',
    SE: 'Sergipe',
    TO: 'Tocantins',
  };

  const MANUAL_LOCAL_DELIVERY_RULE = {
    enabled: true,
    name: 'Entrega Local',
    centerZip: '22430090',
    radiusKm: 10,
    priceCents: 0,
    centerCoordinates: {
      latitude: -22.9803335,
      longitude: -43.2202938,
    },
  };

  const ZIP_COORDINATES_CACHE = new Map();

  function toDigits(value) {
    return String(value || '').replace(/\D/g, '').slice(0, ZIP_LENGTH);
  }

  function formatZip(value) {
    const digits = toDigits(value);

    if (digits.length > 5) {
      return `${digits.slice(0, 5)}-${digits.slice(5)}`;
    }

    return digits;
  }

  function normalizeText(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }

  function normalizeCountry(country) {
    const value = String(country || '').trim();

    if (!value) return 'Brazil';

    const normalized = normalizeText(value);

    if (normalized === 'brasil' || normalized === 'br') return 'Brazil';

    return value;
  }

  function detectBrazilProvinceFromZip(zip) {
    const digits = toDigits(zip);

    if (digits.length < ZIP_LENGTH) return null;

    const prefix = Number.parseInt(digits.slice(0, 5), 10);

    if (!Number.isFinite(prefix)) return null;

    return BRAZIL_PROVINCES_BY_ZIP.find((range) => {
      return prefix >= range.min && prefix <= range.max;
    }) || null;
  }

  function moneyFormat() {
    return window.FoxThemeSettings?.money_format ||
      window.themeVariables?.settings?.moneyFormat ||
      window.theme?.moneyFormat ||
      'R$ {{amount_with_comma_separator}}';
  }

  function parseMoneyToCents(value) {
    const text = String(value || '').trim();

    if (!text) return 0;

    let normalized = text.replace(/[^\d,.-]/g, '');

    if (!normalized) return 0;

    if (normalized.includes(',')) {
      normalized = normalized.replace(/\./g, '').replace(',', '.');
    }

    const parsed = Number.parseFloat(normalized);

    return Number.isFinite(parsed) ? Math.round(parsed * 100) : 0;
  }

  function priceToCents(rate) {
    if (!rate) return 0;

    if (typeof rate.price_cents === 'number') {
      return rate.price_cents;
    }

    if (typeof rate.price === 'number') {
      return Math.round(rate.price * 100);
    }

    return parseMoneyToCents(rate.price || '0');
  }

  function formatPrice(cents) {
    if (typeof formatMoney === 'function') {
      return formatMoney(cents, moneyFormat());
    }

    return (Number(cents || 0) / 100).toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    });
  }

  function getDeliveryText(rate) {
    if (!rate) return '';

    if (Array.isArray(rate.delivery_days) && rate.delivery_days.length > 0) {
      const days = rate.delivery_days
        .map((day) => Number.parseInt(day, 10))
        .filter((day) => Number.isFinite(day));

      if (days.length > 0) {
        return `${Math.max(...days)} DIAS ÚTEIS`;
      }
    }

    const deliveryText = rate.delivery_date || rate.delivery_range || rate.description || '';

    return String(deliveryText).trim().toUpperCase();
  }

  function getShippingRateDisplayName(rate) {
    return String(rate?.name || '').trim();
  }

  function buildRateLabel(rate) {
    const rateName = getShippingRateDisplayName(rate);
    const price = formatPrice(priceToCents(rate));
    const deliveryText = getDeliveryText(rate);

    return `${rateName} - ${price}${deliveryText ? ` (${deliveryText})` : ''}`;
  }

  function isLocalDeliveryRate(rate) {
    const name = normalizeText(rate?.name || '');

    return name.includes('entrega local') || name.includes('local delivery');
  }

  function extractCoordinatesFromBrasilApi(data) {
    const coordinates = data?.location?.coordinates;

    if (!coordinates) return null;

    const latitude = Number.parseFloat(coordinates.latitude ?? coordinates.lat ?? coordinates[1]);
    const longitude = Number.parseFloat(coordinates.longitude ?? coordinates.lng ?? coordinates.lon ?? coordinates[0]);

    if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) return null;

    return { latitude, longitude };
  }

  async function fetchCoordinatesByZip(zip, signal) {
    const digits = toDigits(zip);

    if (digits.length !== ZIP_LENGTH) return null;

    if (digits === MANUAL_LOCAL_DELIVERY_RULE.centerZip) {
      return MANUAL_LOCAL_DELIVERY_RULE.centerCoordinates;
    }

    if (ZIP_COORDINATES_CACHE.has(digits)) {
      return ZIP_COORDINATES_CACHE.get(digits);
    }

    try {
      const response = await fetch(`https://brasilapi.com.br/api/cep/v2/${digits}`, { signal });

      if (!response.ok) {
        ZIP_COORDINATES_CACHE.set(digits, null);
        return null;
      }

      const data = await response.json();
      const coordinates = extractCoordinatesFromBrasilApi(data);

      ZIP_COORDINATES_CACHE.set(digits, coordinates);

      return coordinates;
    } catch (error) {
      if (error.name !== 'AbortError') {
        console.warn('[ECOMHARD] Não foi possível buscar coordenadas do CEP:', error);
      }

      return null;
    }
  }

  function degreesToRadians(value) {
    return (Number(value) * Math.PI) / 180;
  }

  function calculateDistanceInKm(origin, destination) {
    if (!origin || !destination) return null;

    const originLatitude = Number.parseFloat(origin.latitude);
    const originLongitude = Number.parseFloat(origin.longitude);
    const destinationLatitude = Number.parseFloat(destination.latitude);
    const destinationLongitude = Number.parseFloat(destination.longitude);

    if (
      !Number.isFinite(originLatitude) ||
      !Number.isFinite(originLongitude) ||
      !Number.isFinite(destinationLatitude) ||
      !Number.isFinite(destinationLongitude)
    ) {
      return null;
    }

    const earthRadiusInKm = 6371;
    const latitudeDistance = degreesToRadians(destinationLatitude - originLatitude);
    const longitudeDistance = degreesToRadians(destinationLongitude - originLongitude);

    const a =
      Math.sin(latitudeDistance / 2) * Math.sin(latitudeDistance / 2) +
      Math.cos(degreesToRadians(originLatitude)) *
        Math.cos(degreesToRadians(destinationLatitude)) *
        Math.sin(longitudeDistance / 2) *
        Math.sin(longitudeDistance / 2);

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    return earthRadiusInKm * c;
  }

  async function buildManualLocalDeliveryRate(zip, signal) {
    if (!MANUAL_LOCAL_DELIVERY_RULE.enabled) return null;

    const digits = toDigits(zip);

    if (digits.length !== ZIP_LENGTH) return null;

    const coordinates = await fetchCoordinatesByZip(digits, signal);

    if (!coordinates) return null;

    const distanceKm = calculateDistanceInKm(
      MANUAL_LOCAL_DELIVERY_RULE.centerCoordinates,
      coordinates
    );

    if (!Number.isFinite(distanceKm) || distanceKm > MANUAL_LOCAL_DELIVERY_RULE.radiusKm) {
      return null;
    }

    return {
      name: MANUAL_LOCAL_DELIVERY_RULE.name,
      price: '0.00',
      price_cents: MANUAL_LOCAL_DELIVERY_RULE.priceCents,
      description: '',
      delivery_days: [],
      _ecomhardManualLocalDelivery: true,
      _ecomhardDistanceKm: distanceKm,
    };
  }

  function mergeManualLocalDeliveryRate(rates, manualLocalDeliveryRate) {
    const safeRates = Array.isArray(rates) ? [...rates] : [];

    if (!manualLocalDeliveryRate) return safeRates;

    const alreadyHasLocalDelivery = safeRates.some(isLocalDeliveryRate);

    if (alreadyHasLocalDelivery) return safeRates;

    return [manualLocalDeliveryRate, ...safeRates];
  }

  function getErrorMessageFromResult(result) {
    if (!result || typeof result !== 'object') return '';

    const firstError = Object.values(result).find((value) => {
      return Array.isArray(value) && value.length;
    });

    return firstError ? firstError[0] : '';
  }

  async function fetchAddressByZip(zip, signal) {
    const digits = toDigits(zip);

    if (digits.length !== ZIP_LENGTH) return null;

    try {
      const response = await fetch(`https://viacep.com.br/ws/${digits}/json/`, { signal });

      if (!response.ok) return null;

      const data = await response.json();

      if (!data || data.erro) return null;

      const provinceCode = String(data.uf || '').trim().toUpperCase();
      const province = UF_TO_STATE_NAME[provinceCode] || provinceCode;

      return {
        zip: formatZip(digits),
        zipDigits: digits,
        address1: String(data.logradouro || '').trim(),
        neighborhood: String(data.bairro || '').trim(),
        city: String(data.localidade || '').trim(),
        provinceCode,
        province,
        country: 'Brazil',
      };
    } catch (error) {
      if (error.name !== 'AbortError') {
        console.warn('[ECOMHARD] Não foi possível buscar endereço pelo CEP:', error);
      }

      return null;
    }
  }

  function buildFallbackAddress(zip) {
    const detectedProvince = detectBrazilProvinceFromZip(zip);
    const digits = toDigits(zip);

    return {
      zip: formatZip(digits),
      zipDigits: digits,
      address1: '',
      neighborhood: '',
      city: '',
      provinceCode: detectedProvince?.provinceCode || '',
      province: detectedProvince?.province || '',
      country: 'Brazil',
    };
  }

  async function fetchCart(signal) {
    const response = await fetch('/cart.js', {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
      signal,
    });

    return response.json();
  }

  async function clearCart(signal) {
    const response = await fetch('/cart/clear.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({}),
      signal,
    });

    return response.json();
  }

  async function addCartItems(items, signal) {
    if (!Array.isArray(items) || !items.length) return null;

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ items }),
      signal,
    });

    return response.json();
  }

  async function updateCart(payload, signal) {
    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
      signal,
    });

    return response.json();
  }

  function getSellingPlanId(item) {
    return item?.selling_plan_allocation?.selling_plan?.id || null;
  }

  function cartItemToAddPayload(item) {
    const payload = {
      id: item.variant_id,
      quantity: item.quantity,
    };

    if (item.properties && Object.keys(item.properties).length) {
      payload.properties = item.properties;
    }

    const sellingPlanId = getSellingPlanId(item);

    if (sellingPlanId) {
      payload.selling_plan = sellingPlanId;
    }

    return payload;
  }

  async function restoreCart(snapshot, signal) {
    await clearCart(signal);

    const itemsToRestore = Array.isArray(snapshot?.items)
      ? snapshot.items.map(cartItemToAddPayload).filter((item) => item.id && item.quantity > 0)
      : [];

    if (itemsToRestore.length) {
      await addCartItems(itemsToRestore, signal);
    }

    await updateCart(
      {
        note: snapshot?.note || '',
        attributes: snapshot?.attributes || {},
      },
      signal
    );

    document.dispatchEvent(
      new CustomEvent('cart:updated', {
        detail: {
          source: 'product-shipping-calculator',
          restored: true,
        },
      })
    );
  }

  async function fetchShippingRates({ zip, country, province, provinceCode, city, address1, signal }) {
    const url = new URL('/cart/shipping_rates.json', window.location.origin);

    url.searchParams.set('shipping_address[zip]', formatZip(zip));
    url.searchParams.set('shipping_address[country]', normalizeCountry(country || 'Brazil'));

    if (province) {
      url.searchParams.set('shipping_address[province]', province);
    }

    if (provinceCode) {
      url.searchParams.set('shipping_address[province_code]', provinceCode);
    }

    if (city) {
      url.searchParams.set('shipping_address[city]', city);
    }

    if (address1) {
      url.searchParams.set('shipping_address[address1]', address1);
    }

    const response = await fetch(url.toString(), { signal });

    return response.json();
  }

  customElements.define(
    'product-calc-shipping-rate-block',
    class ProductCalcShippingRates extends HTMLElement {
      constructor() {
        super();

        this.rates = [];
        this.selectedRate = null;
        this.selectedRateIndex = 0;
        this.debounceTimer = null;
        this.abortController = null;
        this.initialized = false;
        this.isSimulatingCart = false;

        this.handleInput = this.handleInput.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
        this.handleRateChange = this.handleRateChange.bind(this);
        this.handleClear = this.handleClear.bind(this);
        this.handleProductChange = this.handleProductChange.bind(this);
      }

      connectedCallback() {
        if (this.initialized) return;

        this.initialized = true;

        this.selectors = {
          zipCode: '[name="address[zip]"]',
          message: '[data-shipping-message]',
          price: '[data-shipping-price]',
          clearButton: '[data-shipping-clear]',
        };

        this.domNodes = {
          zipCode: this.querySelector(this.selectors.zipCode),
          message: this.querySelector(this.selectors.message),
          price: this.querySelector(this.selectors.price),
          clearButton: this.querySelector(this.selectors.clearButton),
        };

        if (!this.domNodes.zipCode || !this.domNodes.message || !this.domNodes.price) return;

        this.domNodes.zipCode.value = formatZip(this.domNodes.zipCode.value);

        this.domNodes.zipCode.addEventListener('input', this.handleInput);
        this.domNodes.zipCode.addEventListener('keydown', this.handleKeydown);
        this.domNodes.zipCode.addEventListener('blur', () => {
          this.domNodes.zipCode.value = formatZip(this.domNodes.zipCode.value);
        });

        if (this.domNodes.clearButton) {
          this.domNodes.clearButton.addEventListener('click', this.handleClear);
        }

        document.addEventListener('change', this.handleProductChange);
      }

      disconnectedCallback() {
        document.removeEventListener('change', this.handleProductChange);

        if (this.domNodes?.clearButton) {
          this.domNodes.clearButton.removeEventListener('click', this.handleClear);
        }

        if (this.abortController) {
          this.abortController.abort();
        }
      }

      getProductForm() {
        const productFormId = this.dataset.productFormId;

        if (productFormId) {
          const form = document.getElementById(productFormId);

          if (form) return form;
        }

        return this.closest('product-info')?.querySelector('form[action*="/cart/add"]') ||
          document.querySelector('form[action*="/cart/add"]');
      }

      getSelectedVariantId() {
        const form = this.getProductForm();

        const formVariantInput = form?.querySelector('[name="id"]');

        if (formVariantInput?.value) {
          return Number.parseInt(formVariantInput.value, 10);
        }

        const productFormId = this.dataset.productFormId;

        if (productFormId) {
          const externalVariantInput = document.querySelector(`[form="${CSS.escape(productFormId)}"][name="id"]`);

          if (externalVariantInput?.value) {
            return Number.parseInt(externalVariantInput.value, 10);
          }
        }

        return 0;
      }

      getQuantity() {
        const form = this.getProductForm();
        const productFormId = this.dataset.productFormId;

        const quantityInput =
          form?.querySelector('[name="quantity"]') ||
          (productFormId
            ? document.querySelector(`[form="${CSS.escape(productFormId)}"][name="quantity"]`)
            : null) ||
          document.querySelector('.product-form__quantity [name="quantity"], quantity-input [name="quantity"]');

        const quantity = Number.parseInt(quantityInput?.value || '1', 10);

        return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
      }

      getProductPriceCents() {
        const priceFromDataset = Number.parseInt(this.dataset.productPriceCents || '0', 10);

        if (Number.isFinite(priceFromDataset) && priceFromDataset > 0) {
          return priceFromDataset;
        }

        const priceElement =
          this.closest('product-info')?.querySelector('.price-item--regular, .price-item--sale, [data-product-price]') ||
          document.querySelector('.price-item--regular, .price-item--sale, [data-product-price]');

        return parseMoneyToCents(priceElement?.textContent || '');
      }

      handleProductChange(event) {
        const target = event.target;

        if (!(target instanceof Element)) return;

        const productFormId = this.dataset.productFormId;
        const isProductField =
          target.matches('[name="id"], [name="quantity"]') ||
          target.closest('variant-selects, variant-radios, product-info, quantity-input');

        const belongsToProductForm =
          !productFormId ||
          target.getAttribute('form') === productFormId ||
          this.getProductForm()?.contains(target) ||
          this.closest('product-info')?.contains(target);

        if (!isProductField || !belongsToProductForm) return;

        const zipDigits = toDigits(this.domNodes.zipCode.value);

        if (zipDigits.length === ZIP_LENGTH) {
          window.clearTimeout(this.debounceTimer);

          this.debounceTimer = window.setTimeout(() => {
            this.fetchRates({ keepSelectedIndex: true });
          }, 250);
        } else {
          this.clearSelectedShipping(false);
        }
      }

      handleInput(event) {
        const formattedZip = formatZip(event.target.value);
        event.target.value = formattedZip;

        const zipDigits = toDigits(formattedZip);

        if (zipDigits.length < ZIP_LENGTH) {
          this.clearRates();
          return;
        }

        window.clearTimeout(this.debounceTimer);

        this.debounceTimer = window.setTimeout(() => {
          this.fetchRates();
        }, DEBOUNCE_TIME);
      }

      handleKeydown(event) {
        if (event.key !== 'Enter') return;

        event.preventDefault();

        const zipDigits = toDigits(this.domNodes.zipCode.value);

        if (zipDigits.length === ZIP_LENGTH) {
          window.clearTimeout(this.debounceTimer);
          this.fetchRates();
        }
      }

      handleRateChange(event) {
        this.selectRate(Number(event.target.value));
      }

      handleClear(event) {
        event.preventDefault();

        if (this.abortController) {
          this.abortController.abort();
        }

        window.clearTimeout(this.debounceTimer);

        this.domNodes.zipCode.value = '';
        this.domNodes.message.innerHTML = '';
        this.rates = [];

        this.clearSelectedShipping(false);
        this.setLoading(false);

        this.domNodes.zipCode.focus();
      }

      async simulateProductCartAndFetchRates(address, signal) {
        const variantId = this.getSelectedVariantId();
        const quantity = this.getQuantity();

        if (!variantId) {
          throw new Error('Não foi possível identificar a variante selecionada.');
        }

        const snapshot = await fetchCart(signal);

        try {
          this.isSimulatingCart = true;

          await clearCart(signal);

          await addCartItems(
            [
              {
                id: variantId,
                quantity,
              },
            ],
            signal
          );

          let result = await fetchShippingRates({
            zip: address.zipDigits || address.zip,
            country: address.country,
            province: address.province,
            provinceCode: address.provinceCode,
            city: address.city,
            address1: address.address1,
            signal,
          });

          if (
            (!Array.isArray(result?.shipping_rates) || result.shipping_rates.length === 0) &&
            address.provinceCode &&
            address.province &&
            normalizeText(address.provinceCode) !== normalizeText(address.province)
          ) {
            result = await fetchShippingRates({
              zip: address.zipDigits || address.zip,
              country: address.country,
              province: address.provinceCode,
              provinceCode: address.provinceCode,
              city: address.city,
              address1: address.address1,
              signal,
            });
          }

          return result;
        } finally {
          await restoreCart(snapshot, signal);
          this.isSimulatingCart = false;
        }
      }

      async fetchRates(options = {}) {
        const zip = toDigits(this.domNodes.zipCode.value);

        if (zip.length !== ZIP_LENGTH) return;

        if (this.abortController) {
          this.abortController.abort();
        }

        this.abortController = new AbortController();
        const currentController = this.abortController;

        this.setLoading(true);
        this.domNodes.message.innerHTML = '';

        try {
          const address = (await fetchAddressByZip(zip, this.abortController.signal)) || buildFallbackAddress(zip);
          const currentZip = toDigits(this.domNodes.zipCode?.value || '');

          if (currentZip !== zip) return;

          if (!address.province && !address.provinceCode) {
            this.renderMessage('Não foi possível identificar o estado desse CEP.');
            this.clearSelectedShipping(false);
            return;
          }

          const result = await this.simulateProductCartAndFetchRates(address, this.abortController.signal);

          const manualLocalDeliveryRate = await buildManualLocalDeliveryRate(
            zip,
            this.abortController.signal
          );

          const mergedShippingRates = mergeManualLocalDeliveryRate(
            result?.shipping_rates,
            manualLocalDeliveryRate
          );

          if (mergedShippingRates.length > 0) {
            this.renderRates(mergedShippingRates, options);
            return;
          }

          if (Array.isArray(result?.shipping_rates) && result.shipping_rates.length === 0) {
            this.renderMessage(
              'Não encontramos fretes para esse CEP. Você ainda pode finalizar a compra para confirmar no checkout.'
            );
            this.clearSelectedShipping(false);
            return;
          }

          const errorMessage = getErrorMessageFromResult(result);

          this.renderMessage(errorMessage || 'Não foi possível calcular o frete.');
          this.clearSelectedShipping(false);
        } catch (error) {
          if (error.name === 'AbortError') return;

          console.warn('[ECOMHARD] Erro ao calcular frete do produto:', error);
          this.renderMessage(error.message || 'Não foi possível calcular o frete.');
          this.clearSelectedShipping(false);
        } finally {
          if (this.abortController === currentController) {
            this.setLoading(false);
          }
        }
      }

      getSafeSelectedIndex(options = {}) {
        const requestedIndex = options.keepSelectedIndex ? this.selectedRateIndex : 0;

        return this.rates[requestedIndex] ? requestedIndex : 0;
      }

      renderRates(rates, options = {}) {
        this.rates = Array.isArray(rates) ? rates : [];
        this.domNodes.message.innerHTML = '';

        if (!this.rates.length) {
          this.renderMessage('Não encontramos fretes para esse CEP.');
          this.clearSelectedShipping(false);
          return;
        }

        const select = document.createElement('select');

        select.className = 'f-cart-shipping__select';
        select.setAttribute('aria-label', 'Escolha o frete');

        this.rates.forEach((rate, index) => {
          const option = document.createElement('option');

          option.value = String(index);
          option.textContent = buildRateLabel(rate);
          option.dataset.priceCents = String(priceToCents(rate));

          select.appendChild(option);
        });

        select.addEventListener('change', this.handleRateChange);

        this.domNodes.message.appendChild(select);

        const safeIndex = this.getSafeSelectedIndex(options);

        select.value = String(safeIndex);

        this.selectRate(safeIndex);
      }

      selectRate(index = 0) {
        const rate = this.rates[index];

        if (!rate) {
          this.clearSelectedShipping(false);
          return;
        }

        const priceCents = priceToCents(rate);

        this.selectedRate = rate;
        this.selectedRateIndex = index;

        this.domNodes.price.textContent = formatPrice(priceCents);

        this.classList.add('has-rates');

        if (this.domNodes.clearButton) {
          this.domNodes.clearButton.removeAttribute('hidden');
        }

        this.updateTotal(priceCents);
      }

      clearRates() {
        window.clearTimeout(this.debounceTimer);

        this.domNodes.message.innerHTML = '';
        this.rates = [];

        this.clearSelectedShipping(false);
      }

      clearSelectedShipping() {
        this.selectedRate = null;
        this.selectedRateIndex = 0;

        this.classList.remove('has-rates');

        this.domNodes.price.textContent = '--';

        if (this.domNodes.clearButton) {
          this.domNodes.clearButton.setAttribute('hidden', 'hidden');
        }

        this.updateTotal(null);
      }

      getOrCreateTotalRow() {
        let totalRow = this.querySelector('[data-product-shipping-total-row]');

        if (totalRow) return totalRow;

        totalRow = document.createElement('div');
        totalRow.className = 'product-shipping-simulator__total-row';
        totalRow.setAttribute('data-product-shipping-total-row', '');
        totalRow.setAttribute('hidden', 'hidden');
        totalRow.innerHTML = `
          <span class="product-shipping-simulator__total-label">Total com frete</span>
          <span class="product-shipping-simulator__total-value" data-product-shipping-total></span>
        `;

        totalRow.style.display = 'flex';
        totalRow.style.justifyContent = 'space-between';
        totalRow.style.gap = '1.2rem';
        totalRow.style.marginTop = '0.8rem';
        totalRow.style.fontSize = '14px';

        this.domNodes.message.insertAdjacentElement('afterend', totalRow);

        return totalRow;
      }

      updateTotal(priceCents = undefined) {
        const totalRow = this.getOrCreateTotalRow();

        if (!totalRow) return;

        const totalValue = totalRow.querySelector('[data-product-shipping-total]');

        if (!totalValue) return;

        if (priceCents === null || typeof priceCents === 'undefined') {
          totalRow.setAttribute('hidden', 'hidden');
          totalValue.textContent = '';
          return;
        }

        const productPriceCents = this.getProductPriceCents();
        const quantity = this.getQuantity();
        const productTotalCents = productPriceCents * quantity;

        if (!productTotalCents) {
          totalRow.setAttribute('hidden', 'hidden');
          totalValue.textContent = '';
          return;
        }

        totalValue.textContent = formatPrice(productTotalCents + priceCents);
        totalRow.removeAttribute('hidden');
      }

      renderMessage(message) {
        this.domNodes.message.innerHTML = '';

        const messageElement = document.createElement('p');
        messageElement.className = 'f-cart-shipping__message-text';
        messageElement.textContent = message;

        this.domNodes.message.appendChild(messageElement);
      }

      setLoading(isLoading) {
        this.classList.toggle('is-loading', isLoading);

        if (this.domNodes?.zipCode) {
          this.domNodes.zipCode.toggleAttribute('readonly', isLoading);
        }
      }
    }
  );
}